module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"occupation":"occupation"},"es":{"occupation":"Ocupación"}}')
  delete Component.options._Ctor
}
